/* eslint-disable react/no-unknown-property */
import { FC } from 'react';

export const LensIcon: FC = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="lens-icon">
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#E6EDFD" />
    <path
      d="M27 35C31.4183 35 35 31.4183 35 27C35 22.5817 31.4183 19 27 19C22.5817 19 19 22.5817 19 27C19 31.4183 22.5817 35 27 35Z"
      stroke="#195AFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M36.9999 37L32.6499 32.65" stroke="#195AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F2F6FE" strokeWidth="8" />
  </svg>
);
